import React from 'react';

const colorMap = {
  'buste': { bg: '#E8EAF6', fg: '#283593', icon: '📦' },
  'busta': { bg: '#E8EAF6', fg: '#283593', icon: '📦' },
  'sacchett': { bg: '#E8EAF6', fg: '#283593', icon: '🛍️' },
  'dischi': { bg: '#FFEBEE', fg: '#E91E63', icon: '🍔' },
  'disco': { bg: '#FFEBEE', fg: '#E91E63', icon: '🍔' },
  'hamburger': { bg: '#FFEBEE', fg: '#E91E63', icon: '🍔' },
  'carta-forno': { bg: '#FFF8E1', fg: '#F57F17', icon: '🧁' },
  'carta forno': { bg: '#FFF8E1', fg: '#F57F17', icon: '🧁' },
  'bisiliconat': { bg: '#FFF8E1', fg: '#F57F17', icon: '🧁' },
  'alluminio': { bg: '#C0C0C0', fg: '#666', icon: '🔲' },
  'truciolo': { bg: '#E8F5E9', fg: '#2E7D32', icon: '🎁' },
  'bobine': { bg: '#E3F2FD', fg: '#1565C0', icon: '📜' },
  'bobina': { bg: '#E3F2FD', fg: '#1565C0', icon: '📜' },
  'fogli': { bg: '#E0F7FA', fg: '#00838F', icon: '📄' },
  'foglio': { bg: '#E0F7FA', fg: '#00838F', icon: '📄' },
  'formati': { bg: '#F3E5F5', fg: '#7B1FA2', icon: '🥖' },
  'tovaglie': { bg: '#FFF3E0', fg: '#E65100', icon: '🍽️' },
  'tovaglia': { bg: '#FFF3E0', fg: '#E65100', icon: '🍽️' },
  'film': { bg: '#E0F2F1', fg: '#00695C', icon: '🔄' },
  'pvc': { bg: '#E0F2F1', fg: '#00695C', icon: '🔄' },
  'poliolefin': { bg: '#E0F2F1', fg: '#00695C', icon: '🔄' },
  'pellicola': { bg: '#E0F2F1', fg: '#00695C', icon: '🔄' },
  'io chef': { bg: '#FCE4EC', fg: '#880E4F', icon: '👨‍🍳' },
  'ppl': { bg: '#E3F2FD', fg: '#0D47A1', icon: '✨' },
  'metallizzat': { bg: '#FFFDE7', fg: '#F9A825', icon: '🌟' },
  'sealing': { bg: '#EFEBE9', fg: '#4E342E', icon: '📋' },
  'kraft': { bg: '#EFEBE9', fg: '#4E342E', icon: '🛍️' },
  'cellophane': { bg: '#E8F5E9', fg: '#388E3C', icon: '🌿' },
  'hydrostar': { bg: '#E1F5FE', fg: '#0277BD', icon: '💧' },
  'perlafol': { bg: '#F3E5F5', fg: '#7B1FA2', icon: '✨' },
  'parafin': { bg: '#FBE9E7', fg: '#BF360C', icon: '🛡️' },
  'sottovuoto': { bg: '#E8EAF6', fg: '#303F9F', icon: '🔒' },
  'fiorist': { bg: '#FCE4EC', fg: '#E91E63', icon: '🌹' },
  'rose': { bg: '#FCE4EC', fg: '#E91E63', icon: '🌹' },
  'legno': { bg: '#EFEBE9', fg: '#5D4037', icon: '🪵' },
  'default': { bg: '#FCE4EC', fg: '#E91E63', icon: '📦' }
};

const PlaceholderImage = ({ name, type = 'product', category = '', width = '100%', height = '100%' }) => {
  const nameLower = name.toLowerCase();
  const matchKey = Object.keys(colorMap).find(key => nameLower.includes(key));
  const colors = matchKey ? colorMap[matchKey] : colorMap.default;
  const displayIcon = matchKey ? colorMap[matchKey].icon : colorMap.default.icon;

  return (
    <div style={{
      width,
      height,
      minHeight: '120px',
      background: `linear-gradient(135deg, ${colors.bg}, ${colors.bg}dd)`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      gap: '8px'
    }}>
      <span style={{ fontSize: '40px' }}>{displayIcon}</span>
      <span style={{
        fontSize: '12px',
        fontWeight: '600',
        color: colors.fg,
        textAlign: 'center',
        padding: '0 10px',
        maxWidth: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
        {name}
      </span>
    </div>
  );
};

export default PlaceholderImage;
